import { Card } from "./Card";

export interface SDGData {
  title: string;
  description: string;
  departments: string[];
  link: string;
}

interface SDGPolicyProps {
  data: SDGData | null;
  isLoading: boolean;
}

export function SDGPolicyCard({ data, isLoading }: SDGPolicyProps) {
  return (
    <Card>
      <h2 className="text-xl font-semibold mb-4">SDG Policy</h2>
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <div className="text-gray-400">Loading SDG policy...</div>
        </div>
      ) : !data ? (
        <div className="flex justify-center items-center h-full">
          <div className="text-gray-400">No SDG policy available.</div>
        </div>
      ) : (
        <div className="space-y-3">
          {data.link ? (
            <a
              href={data.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-blue-400 underline"
            >
              {data.title}
            </a>
          ) : (
            <p className="text-gray-400 text-sm">{data.title}</p>
          )}

          <p className="text-gray-300 text-sm">{data.description}</p>

          <div className="pt-2">
            <span className="text-xs text-gray-500 uppercase">
              {data.departments.join(", ")}
            </span>
          </div>
        </div>
      )}
    </Card>
  );
}
